
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";

import Modal from "./../../elements/Modal";
import commoncss from "./../../css/common.module.css";
import { Button } from "./../../elements/Button";
import buttoncss from "./../../css/button.module.css";
import Dropdown from "./../../elements/Dropdown";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { useState, useRef } from "react";

const PullDataModal = ({
  companies,
  handleClose,
  setPullModal,
  displayModal,
  pullModal,
  setPullModalData,
}) => {
  const dateFromRef = useRef();
  const dateToRef = useRef();

  const [company, setCompany] = useState(null);
  const [transdatefrom, setTransdatefrom] = useState(null);
  const [transdateto, setTransdateto] = useState(null);

  const pullData = () => {
    const pullDataObj = {
      companyid: company?.value,
      companyname: company?.label,
      transdatefrom,
      transdateto,
    };
    setPullModalData(pullDataObj, "PULL");
  };

  return (
    <Modal
      title="Pull Data"
      headerActions={
        <CloseIcon
          onClick={() => {
            handleClose();
            setPullModal(false);
          }}
          className="clickable"
        />
      }
      footer={<span></span>}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              handleClose();
              setPullModal(false);
            }}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label="Pull Data"
            onClick={pullData}
          />
        </>
      }
      onClose={() => console.log("Modal Closed")}
    >
      <Dropdown
        label="Select Company"
        options={companies.map((company) => ({
          label: company.company_name,
          value: company._id,
        }))}
        onSelect={(value) => setCompany(value)}
        placeHolder="Select Company"
      />

      <InputGroup
        label="Select Date"
        inputs={[
          //     <>
          //       <input
          //         type="date"
          //         className="dateInput"
          //         value={transdatefrom || ""}
          //         ref={dateFromRef}
          //         onChange={(e) => setTransdatefrom(e.target.value)}
          //       />
          //       <span
          //         className="icon clickable"
          //       >
          //         <CalenderIcon className="vaMiddle" width={25} height={25}
          // onClick={() => dateFromRef.current?.showPicker?.()} />
          //       </span>
          //     </>,
          <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                <MobileDatePicker
                  className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                  value={dayjs(transdatefrom)}
                  onChange={(value) => {
                    setTransdatefrom(value)
                  }}
                  format="DD-MMM-YYYY"
                  slotProps={{
                    textField: {
                      InputProps: {
                        disableUnderline: true,
                      },
                      sx: {
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            <span className="icon">
              <CalenderIcon className="vaMiddle" width={20} height={20} />
            </span>
          </>,
          <>
            {/* <input
              type="date"
              className="dateInput"
              value={transdateto || ""}
              ref={dateToRef}
              onChange={(e) => setTransdateto(e.target.value)}
            />
            <span
              className="icon clickable"
              onClick={() => dateToRef.current?.showPicker?.()}
            >
              <CalenderIcon className="vaMiddle" width={25} height={25} />
            </span> */}

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                <MobileDatePicker
                  className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                  value={dayjs(transdateto)}
                  onChange={(value) => {
                    setTransdateto(value)
                  }}
                  format="DD-MMM-YYYY"
                  slotProps={{
                    textField: {
                      InputProps: {
                        disableUnderline: true,
                      },
                      sx: {
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            <span className="icon">
              <CalenderIcon className="vaMiddle" width={20} height={20} />
            </span>
          </>,
        ]}
      />
    </Modal>
  );
};

export default PullDataModal;
